var _g, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#050505",
    className: "fill-263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.586 23.586c.122-.122.262-.217.408-.299l-2.276-2.277a.5.5 0 0 0-.707.708l2.271 2.271a2.03 2.03 0 0 1 .304-.403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31c-.667 0-1.295-.26-1.768-.732l-3.5-3.5c-.472-.473-.732-1.1-.732-1.768s.26-1.295.732-1.768c.906-.906 2.629-.906 3.535 0l3.5 3.5c.473.473.733 1.1.733 1.768s-.26 1.295-.732 1.768S29.167 31 28.5 31zM25 23.52a1.5 1.5 0 0 0-1.061.42c-.283.283-.439.66-.439 1.06s.156.777.439 1.061l3.5 3.5c.567.566 1.554.566 2.121 0 .284-.284.44-.661.44-1.061s-.156-.777-.439-1.061l-3.5-3.5A1.504 1.504 0 0 0 25 23.52z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.45a.5.5 0 0 1 0-1c3.767 0 7.035-2.404 8.133-5.981a.5.5 0 0 1 .957.293c-1.229 4.001-4.881 6.688-9.09 6.688z",
    fill: "#050505",
    className: "fill-263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C6.383 25 1 19.617 1 13S6.383 1 13 1s12 5.383 12 12-5.383 12-12 12zm0-23C6.935 2 2 6.935 2 13s4.935 11 11 11 11-4.935 11-11S19.065 2 13 2z",
    fill: "#050505",
    className: "fill-263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 13,
    fill: "#050505",
    r: 0.5,
    className: "fill-263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.93bfe41c418f1500f058fb61954bb99a.svg";
export { ForwardRef as ReactComponent };